<template>
    <div class="shareGuide" @touchmove.prevent @mousewheel.prevent>
        <!-- 分享、关注 -->
        <div class="fixed_btn shareWx" :class="isHarvard? 'fixed_btn_y':''" v-show="shareWxFlag" @click="showShare"><span><van-icon name="share" />分享</span></div>
        <div class="fixed_btn attention" :class="isHarvard? 'fixed_btn_y':''" v-show="attentionFlag" @click="showAttention"><span><van-icon name="like-o" />关注</span></div>
        <!-- 分享弹窗 -->
        <div class="attent-shade shareWxFlag" @touchmove.prevent>
            <div  class="share_desc">
                <p class="share-line"><img src="../../assets/images/baby/line.png"/></p>
                <p>一、先点击“ <van-icon name="ellipsis"  size="25px"/> ”</p>
                <p>二、再点击“ <img src="../../assets/images/baby/share.jpg"/> ”分享至朋友圈 或“ <img class="shareFriend" src="../../assets/images/baby/send.jpg"/> ”发给朋友</p>
                <div class="btn_close" @click="closeShare"><van-icon name="close" /></div>
            </div>
        </div>
        <div class="attent-shade attentionFlag" @touchmove.prevent>
            <div class="attention">
                <p class="title">长按扫码关注星妈会<br/>开启快乐育儿&nbsp;&nbsp;领取积分好礼</p>
                <div class="attent-img"><img src="../../assets/images/baby/2wei.png"/></div>
                <div class="attent-class">
                    <div class="attent-item">
                        <div><img src="../../assets/images/icon/icon1.png"/></div>
                        <p>专家问答<br/> 为您解决育儿烦恼</p>
                    </div>
                    <div class="attent-item">
                        <div><img src="../../assets/images/icon/icon2.png"/></div>
                        <p>星妈优选<br/> 精选育儿佳品</p>
                    </div>
                    <div class="attent-item">
                        <div><img src="../../assets/images/icon/Icon3.png"/></div>
                        <p>育儿提醒<br/> 您专属的育儿工具</p>
                    </div>
                    <div class="attent-item">
                        <div><img src="../../assets/images/icon/icon4.png"/></div>
                        <p>精品课程<br/> 百余名知名育儿专家</p>
                    </div>
                </div>
                <div class="btn" @click="closeAttention"><van-icon name="close" /></div>
            </div>
        </div>
    </div>
</template>
<style lang="less" scoped>
.shareGuide{
    // 关注、分享
    .fixed_btn{
        width:44px;
        height:44px;
        box-shadow:0px 4px 10px 0px rgba(0,0,0,0.24);
        position: fixed;
        right: 12px;
        background: @expertFontColor255;
        border-radius:22px;
        text-align: center;
        z-index: 9;
        span{
            .van-icon{
                font-size:@indexFontSize14;
                display: block;
                margin-top: 7px;
            }
        }
    }
    .fixed_btn_y{
        width:50px;
        height:50px;
        background:linear-gradient(90deg,rgba(255,220,133,1) 0%,rgba(241,201,92,1) 100%);
        box-shadow:0px 0px 7px 0px rgba(158,115,0,0.2);
        color: #ffffff;
        border-radius:25px;
        span{
            .van-icon{
                font-size:@indexFontSize18;
                display: block;
                margin-top: 7px;
            }
        }
    }
    .shareWx{
        bottom: 60px;
    }
    .attention{
        bottom: 120px;
    }
    //分享遮罩
    .attent-shade{
        position: fixed;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background:rgba(0,0,0,0.6);
        display: none;
        z-index: 9999;
        // 分享弹窗
        .share_desc{
            font-size:18px;
            font-weight:bold;
            color:@expertFontColor255;
            line-height:28px;
            margin-top: 26px;
            margin-left: 27px;
            p{
                width: 256px;
                img{
                    width:18px;
                    height:18px;
                }
                .shareFriend {
                  width: 23px;
                  height: 20px;
                }
            }
            .share-line{
                text-align: right;
                width: 306px;
                height: 75px;
                img{
                    width: 135px;
                    height: 75px;
                    display: block;
                    float: right;
                }
            }
            .btn_close{
                width:23px;
                height:23px;
                position: fixed;
                bottom: 106px;
                left:175px;
                .van-icon{
                    font-size: @indexFontSize22;
                }
            }
        }

        // 关注弹窗
        .attention{
            color: @expertFontColor255;
            .title{
                margin: 58px auto 10px;
                font-size:18px;
                font-weight:bold;
                color:@expertFontColor255;
                line-height:28px;
                text-align: center;
            }
            .attent-img{
                text-align: center;
                margin-bottom: 16px;
                img{
                width: 168px;
                height: 228px;
                }

            }
            .attent-class{
                padding-left: 37px;
                display: flex;
                flex-wrap: wrap;
               .attent-item{
                   display: flex;
                   margin-right: 27px;
                   margin-bottom: 30px;
                   img{
                        width:22px;
                        height:23px;
                        margin-right: 5px;
                        margin-top: 5px;
                   }
                   p{
                       width:112px;
                        font-size:12px;
                        font-weight:bold;
                        line-height:18px;
                   }
               }

            }
            .btn{
                width: 23px;
                height: 23px;
                position: fixed;
                left:174px;
                .van-icon{
                    font-size: @indexFontSize22;
                }
            }
        }

    }
}
</style>
<script>
import { getCookie} from "@/assets/js/common.js";
export default {
    name:"shareGuide",
    data() {
        return {
            shareWxFlag:false,
            attentionFlag:false,
        }
    },
    props:{
        imageDetail:{
            type: String
        },
        isHarvard:{
            type: Boolean,
            default:false
        }
    },
    mounted(){
        this.isAttention();
        // this.shareWxFlag = true;
    },
    methods:{
        showShare:function(){
            this.videoOpen();
            $(".shareWxFlag").fadeIn(200);
            this.$emit("shareGio");
        },
        closeShare:function(){
            this.videoClose()
            $(".shareWxFlag").fadeOut(200);
        },
        showAttention:function(){
            this.videoOpen();
            $(".attentionFlag").fadeIn(200);
        },
        closeAttention:function(){
            this.videoClose();
            $(".attentionFlag").fadeOut(200);
        },
        // 判断是否关注了星妈会
        isAttention:function(){
            let openId = this.getCookie("xmh_openid");
            if(this.isHarvard){
                this.$http.get(this.$http.harvardBaseURL+"/harvard/checkSub",{"openId":openId},res=>{
                    if(res.code == 200){
                        this.attentionFlag = res.data ? false : true;
                        this.$emit('isAttentFlag',res.data)
                    }else{
                        this.attentionFlag = true;
                    }
                });
            }else{
                this.$http.get("/wechat/checkSub",{"openId":openId},res=>{
                    if(res.code == 200){
                        this.attentionFlag = res.data ? false : true;
                        this.$emit('isAttentFlag',res.data)
                    }else{
                        this.attentionFlag = true;
                    }
                },()=>{},'member');
            }
        },
        //点击分享和关注由于视频层级最高，需要把视频隐藏再展示图片
        videoOpen(){
            if($('video').length > 0){
                this.$parent.$refs.HFVideo.Player.pause();
                $('#HF').css("background-image","url("+this.imageDetail+")");
                $('video').css('display','none');
                $('.xgplayer-controls').css('display','none');
            }
        },
        //点击分享和关注由于视频层级最高，关闭时需要把视频隐藏再展示图片
        videoClose(){
            if($('video').length > 0){
                // this.$parent.$refs.HFVideo.Player.play();
                $('#HF').css("background-image","");
                $('video').css('display','block');
                $('.xgplayer-controls').css('display','');
            }
        },
        getCookie
    }
}
</script>
